import { render, staticRenderFns } from "./TabOutrasReceitas.vue?vue&type=template&id=5741e886"
import script from "./TabOutrasReceitas.vue?vue&type=script&lang=js"
export * from "./TabOutrasReceitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports